import { useEffect } from "react";
import store from "../../redux/store";
import { setShowMiniPlayer } from "../../redux/slices/controllerSlice";
import { conditions } from "../conditions/conditions";
import { ConditionName } from "../../interfaces/enums";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const useHandleScroll = () => {

    useAppSelector(({ videoData: { params } }) => ({ params }), shallowEqual);
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);

    useEffect(() => {
        const { params } = store.getState().videoData;
        const handleScroll = () => {
            if(conditions(ConditionName.hasScrollElementId)) {
                const dispatch = store.dispatch;
                const videoAreaTopPosition = document.getElementById(conditions(ConditionName.showMiniPlayer) ? "black-video-area" : "video-area")!.getBoundingClientRect().top;
                if (videoAreaTopPosition < 0) dispatch(setShowMiniPlayer(true));
                else dispatch(setShowMiniPlayer(false));
            }
        }
        let scrollElement:any;
        if(conditions(ConditionName.hasScrollElementId)) {
            scrollElement = document.getElementById(params.scrollElementId!);
            if (scrollElement) scrollElement.addEventListener("scroll", handleScroll);
        }
        return () => conditions(ConditionName.hasScrollElementId) && scrollElement && scrollElement.removeEventListener("scroll", handleScroll);
    }, [])
}

export default useHandleScroll;